<template>
  <div>
    <div
      class="search-content wrap-apply"
      :show="columnsData.listShow"
      :style="{
        top: GLOBAL.currentEnvironment ? '0!important' : '',
        height: GLOBAL.currentEnvironment ? '100vh' : 'calc(100vh - 1.12rem)',
        paddingBottom: GLOBAL.currentEnvironment ? '0.66rem' : '',
      }"
    >
      <!-- <div class="nav_bar">
        <van-nav-bar
          left-text="返回"
          :title="columnsData.title"
          left-arrow
          fixed
          placeholder
          @click-left="goBack"
        />
      </div> -->

      <div class="action">
        <!-- <div @click="columnsData.checkedShow = !columnsData.checkedShow">
          {{ columnsData.checkedShow ? "取消" : "选择" }}
        </div> -->
        <!-- <div style="display: flex">
          <van-button @click="getList">刷新</van-button>
          <van-button @click="searchQuery">搜索</van-button>
          <van-button @click="searchReset">重置</van-button>
        </div> -->
        <div class="title">
          <slot name="title"></slot>
        </div>
        <div
          class="listBox"
          :style="{
            height: GLOBAL.currentEnvironment
              ? '100vh'
              : 'calc(100vh - 2.12rem)',
            paddingBottom: GLOBAL.currentEnvironment ? '0.66rem' : '',
          }"
        >
          <pageList
            ref="pageList"
            :checkedShow="columnsData.checkedShow"
            :operationTxt="columnsData.operationTxt"
            :columns="columnsData.columns"
            checkedShowText="全选"
            cancelOperationTxt=""
            :listUrl="columnsData.listUrl"
            @getCheckedValue="getCheckedValue"
            @handleList="handleList"
            @operationItem="operationItem"
            @listData="listData"
          >
            <div
              slot="head"
              v-if="columnsData.columns.headSlot"
              slot-scope="{ item, index }"
            >
              <slot name="head" :item="item" :index="index"> </slot>
            </div>
            <div
              slot="body"
              v-if="columnsData.columns.bodySlot"
              slot-scope="{ item, index }"
            >
              <slot name="body" :item="item" :index="index"> </slot>
            </div>
            <div
              slot="label"
              v-if="columnsData.columns.labelSlot"
              slot-scope="{ item, index }"
            >
              <slot name="label" :item="item" :index="index"> </slot>
            </div>
            <div
              slot="foot"
              v-if="columnsData.columns.footSlot"
              slot-scope="{ item, index }"
            >
              <slot name="foot" :item="item" :index="index"> </slot>
            </div>
          </pageList>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import pageList from "@/components/pageList";
export default {
  props: {
    columnsData: {
      type: Object,
      default: function() {
        return {};
      },
    },
  },
  computed: {},
  components: { pageList },
  data() {
    return {};
  },
  methods: {
    goBack() {
      // this.$emit("goBack");
    },
    listData(v) {
      this.$emit("listData", v);
    },
    // 获取选择的列表数据
    getCheckedValue(ids, item) {
      this.$emit("getCheckedValue", ids, item);
      this.columnsData.listShow = false;
    },
    //列表点击事件
    handleList(id, item, type) {
      this.$emit("handleList", id, item, type);
      if (type !== "更多操作") {
        this.columnsData.listShow = false;
      }
    },
    operationItem(a, b) {
      this.$emit("operationItem", a, b);
    },
    // 加载列表
    getList() {
      // 传1代表从第一条数据开始
      this.$refs.pageList.onLoad(1);
    },
    // 搜索
    searchQuery(v) {
      // 搜索条件
      this.$refs.pageList.searchQuery(v);
    },
    // 重置
    searchReset() {
      this.$refs.pageList.searchReset();
    },
  },
  watch: {},
};
</script>

<style lang="scss" scoped>
@import "@/assets/theme.scss";
@import "@/views/workManagement/materialRequisition/materialDetail.scss";
@import "@/views/workManagement/materialRequisition/materialForm.scss";
.action {
  background: #f5f5f5;
  .title {
    position: sticky;
    top: 0;
    z-index: 999;
  }
}
/deep/.operation {
  background: #ffffff !important;
}
.listBox {
  height: calc(100vh - 1.5rem);
  overflow-y: auto;
}
</style>
